export enum HeaderState {
  Standard = 'STANDARD',
  Transparent = 'TRANSPARENT',
  Hidden = 'HIDDEN',
}
